import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // You can add specific props later, e.g., error?: string;
  label?: string;
  containerClassName?: string;
}

const Input: React.FC<InputProps> = ({
  id,
  label,
  type = 'text',
  className,
  containerClassName,
  ...props
}) => {
  const baseInputClasses =
    'block w-full rounded-md border-0 py-2.5 px-3.5 text-sm leading-6 shadow-sm ring-1 ring-inset placeholder:text-text-secondary-light dark:placeholder:text-text-secondary-dark focus:ring-1 focus:ring-inset sm:text-sm sm:leading-6 transition-colors duration-150';

  const themeClasses =
    'bg-surface-light text-text-primary-light ring-border-light focus:ring-border-light dark:bg-surface-darker dark:text-text-primary-dark dark:ring-black dark:focus:ring-black';

  // Example error styling (can be expanded)
  // const errorClasses = props.error ? 'ring-red-500 focus:ring-red-500' : 'focus:ring-text-secondary-light';

  const combinedClassName = `
    ${baseInputClasses}
    ${themeClasses}
    ${className || ''}
  `;

  return (
    <div className={containerClassName || ''}>
      {label && (
        <label
          htmlFor={id || props.name}
          className='block text-sm font-medium leading-6 text-text-primary-light dark:text-text-primary-dark mb-1'
        >
          {label}
        </label>
      )}
      <input
        type={type}
        id={id || props.name}
        className={combinedClassName.trim()}
        {...props}
      />
      {/* {props.error && ( // Example of how to display an error message
        <p className="mt-2 text-sm text-red-500">{props.error}</p>
      )} */}
    </div>
  );
};

export default Input;
